import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../shared/services/apiService.service';
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-tata-mitra',
  templateUrl: './tata-mitra.component.html',
  styleUrls: ['./tata-mitra.component.scss']
})
export class TataMitraComponent implements OnInit {

  environment1 =environment.s3bucket.url;
  sub: Subscription = new Subscription();
  safeUrl!: SafeResourceUrl;
  blogList: any;
  videoType: any;
  tataMitrablogList: any = [];
  productLoaded :boolean = false
  constructor(private ApiService: ApiService, private sanitizer: DomSanitizer,public skeletonService: SkeletonService,public router: Router) { }

  ngOnInit(): void {
    this.getBlogList();
  }

  getBlogList() {
    let data = {
      "offset": 0,
      "limit": 5,
      "blog_status":"APPROVED",
      "action_type": "PRIORITY"


    }
    this.sub.add(this.ApiService.getBlogList(data).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.blogList = response.data;
          for (var k = 0; k < this.blogList?.length; k++) {
            this.videoType = "YouTubeUrl";
            let urls = this.blogList[k]["youtube_url"];

            if (urls) {
              var vthaumbimage = this.youtube_parser(urls);
              let videos = "https://www.youtube.com/embed/" + vthaumbimage + "?autoplay=0&loop=1&autopause=0";
              this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videos);
            }
            else {
              this.safeUrl = "";
            }
            // this.blogList[k].youtube_url=this.safeUrl
              var a = this.formDataVideo(
                this.blogList[k]["id"],
                this.blogList[k]["title"],
                this.blogList[k]["tag"],
                this.blogList[k]["description"],
                this.blogList[k]["youtube_url"],
                this.blogList[k]["image_path"],
                this.blogList[k]["type_of_blog"],
                this.blogList[k]["created_date"],
                this.blogList[k]["author_name"],
                this.blogList[k]["author_image"],
                this.blogList[k]["author_description"],
                this.blogList[k]["type"],
              )
            this.tataMitrablogList.push(a);

          }

          setTimeout(() => {
            this.productLoaded = true
          }, 5000);
        }
      },
      error: () => {

      },
      complete: () => {
      }
    }))
  }

  getURL(URL){
    let url = URL.includes('https://youtu.be/') ? URL?.replace('https://youtu.be/', '') :
     URL.includes('https://www.youtube.com/watch?v=') ? URL?.replace('https://www.youtube.com/watch?v=', '') :
     URL.includes('https://www.youtube.com/embed/') ? URL?.replace('https://www.youtube.com/embed/', '') : URL;

     return url;
    }

    redirectTo(id,title){
      var title = title.replace(/\s/g, "-").replace(/\//g, "-").replace(/\+/g, "-").replace(/\./g, "-").replace(/\,/g, "-").replace(/\:/g, "-").replace(/\?/g, "-");
      var path = 'blogs-and-stories/'+ title+'/'+id;
      this.router.navigate([path]);

      return path;
    }

  youtube_parser(url: any) {
    var regExp =
      /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
    var match = url.match(regExp);
    return match && match[1]?.length == 11 ? match[1] : false;
  }
  platformId() {
    throw new Error('Method not implemented.');
  }

  formDataVideo(id: string, title: string, tag: any, description: string, youtube_url: any, image_path: string, type_of_blog: any, created_date: any, author_name: string, author_image: any, author_description: any, type:any): videoBlogData {
    const userData: videoBlogData = {} as videoBlogData;
    userData.id = id;
    userData.title = title;
    userData.tag = tag;
    userData.description = description;
    userData.youtube_url = youtube_url;
    userData.image_path = image_path;
    userData.type_of_blog = type_of_blog;
    userData.created_date = created_date;
    userData.author_name = author_name;
    userData.author_image = author_image;
    userData.author_description = author_description;
    userData.type=type
    return userData;
  }


}

export interface videoBlogData {
  type: any;
  id: any;
  title: string;
  tag: any;
  description: string;
  youtube_url: any;
  image_path: string;
  type_of_blog: any;
  created_date: any;
  author_name: string;
  author_image: any;
  author_description: any;

}
